export const CUSTOMER_AGENT = {
  id: 'Customer Agent',
  labelKey: 'creditEstimator.agents.customerAgent.name',
  badgeKey: 'creditEstimator.agents.customerAgent.badge',
  currentPlanBadgeKey: 'creditEstimator.agents.customerAgent.currentPlanBadge',
  minTier: 'professional',
  featureType: 'CUSTOMER_AGENT'
};
export const DATA_AGENT = {
  id: 'Data Agent',
  labelKey: 'creditEstimator.agents.dataAgent.name',
  badgeKey: 'creditEstimator.agents.dataAgent.badge',
  currentPlanBadgeKey: 'creditEstimator.agents.dataAgent.currentPlanBadge',
  minTier: 'starter',
  featureType: 'DATA_AGENT'
};